/**
 * Allowed team domains and individual emails for gated access
 * across all AlexAI apps (member portal, knowledge base, energenius, etc.).
 */

export const TEAM_DOMAINS = [
  "@alexepstein.com",
  "@industrialprogress.net",
  "@energyfreedom.org",
];

export const TEAM_EMAILS = [
  "tom@tomwalczak.com",
  "tom+agent@tomwalczak.com",
  "tom+checkly@tomwalczak.com",
  "tom+cursor@tomwalczak.com",
  "oleksandr.halik@gmail.com",
  "brkicismail@gmail.com",
];

export function isTeamMember(email: string | undefined): boolean {
  if (!email) return false;
  const e = email.toLowerCase();
  if (TEAM_DOMAINS.some((d) => e.endsWith(d))) return true;
  return TEAM_EMAILS.includes(e);
}

/** Alias for backward compat — same check, admin-flavored name. */
export const isAdmin = isTeamMember;
